import { createSlice } from '@reduxjs/toolkit'

interface LoadingState {
  blockingOperations: number
}

const initialState: LoadingState = {
  blockingOperations: 0,
}

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    addBlockingOperation(state) {
      state.blockingOperations++
    },
    removeBlockingOperation(state) {
      if (state.blockingOperations > 0) {
        state.blockingOperations--
      }
    },
  },
})

export const { addBlockingOperation, removeBlockingOperation } = loadingSlice.actions

export default loadingSlice.reducer
